import { useMutation, useQuery, useQueryClient } from 'react-query';
import UserAPI from '../Api/user';
import InfluencerAPI from '../Api/influencer';

export type UpdateVendorFormData = {
  sponsor_id: number;
  email: string;
  legal_name: string;
  company_name: string | null; // doing business as
};

export const useUpdateVendor = () =>
  useMutation(
    async ({
      userId,
      formData,
      fileUpload = false,
    }: {
      userId: string;
      formData: UpdateVendorFormData;
      fileUpload?: boolean;
    }) => UserAPI.updateVendor(userId, formData, fileUpload),
    {
      onError: (error) => {
        console.error(error);
      },
    },
  );

type ArchiveInfluencerVariables = {
  id: number;
  archive: boolean;
  params: any;
};

export const useArchiveInfluencer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, archive }: ArchiveInfluencerVariables) =>
      InfluencerAPI.archiveInfluencer(id, archive),
    onSuccess: () => {
      queryClient.invalidateQueries(['influencers']);
    },
    onError: (error) => {
      console.error(error);
    },
  });
};

export const useGetInfluencers = (params: any) =>
  useQuery(['influencers', params], () => InfluencerAPI.getAll(params), {
    enabled: !!params,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 30000,
    cacheTime: 300000,
  });

export const useGetVendorByUserId = (userId: string) =>
  useQuery(['vendor-by-user', userId], () => UserAPI.getVendor(userId));
